export default __webpack_public_path__ + "static/focus-mode-5ebf5fe53facf12f4daf1b5fdb6529c9.mp4";